// extracted by mini-css-extract-plugin
export default {"particleContainer":"Particles_particleContainer__8f1Qv","particle":"Particles_particle__32yov boxShadow","downHide":"Particles_downHide__ii6b+"};